<div class="container-fluid" style="position: relative; height: 100vh; padding-left: 3rem;" *ngIf="showAdminComponents">
  <hr>
  <div class="d-flex justify-content-center mt-5 mb-5">
    <div class="col-md-11 user-table position-relative">
      <div *ngIf="loading" class="top-50 start-50 translate-middle">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div class="table-container">
        <div class="container">
          <div class="row p-3 position-relative align-self">
            <div class="col-md">
              <mdb-form-control>
                <select [(ngModel)]="selectedFilter" ngDefaultControl class="form-select" aria-label="Default select example">
                  <option *ngFor="let filter of filters" [value]="filter.value">{{filter.name}}</option>
                </select>
              </mdb-form-control>
            </div>
            <div class="col-md">
              <mdb-form-control class="d-flex align-items-center">
                <input mdbInput type="search" id="form" class="form-control mr-2"
                       [(ngModel)]="filterText" ngDefaultControl
                       (ngModelChange)="institutionList(pa, selectedFilter, filterText, sortOrder, sortBy)" />
                <label mdbLabel class="form-label p-1" for="form">Search</label>
              </mdb-form-control>
            </div>
          </div>
        </div>

        <table class="table table-sm" [ngClass]="loading || initialLoading ? 'blur-background' : ''">
          <thead>
          <tr>
            <th (click)="sortBy = 'id'; institutionList(pa, selectedFilter, filterText, toggleSortDirection(), sortBy)" class="header-button">
              Id
              <span [ngClass]="{'arrow-up': sortBy === 'id' && sortOrder === 'ascending',
                                'arrow-down': sortBy === 'id' && sortOrder === 'descending'}"></span>
            </th>
            <th (click)="sortBy = 'code'; institutionList(pa, selectedFilter, filterText, toggleSortDirection(), sortBy)" class="header-button">
              Code
              <span [ngClass]="{'arrow-up': sortBy === 'code' && sortOrder === 'ascending',
                                'arrow-down': sortBy === 'code' && sortOrder === 'descending'}"></span>
            </th>
            <th (click)="sortBy = 'name'; institutionList(pa, selectedFilter, filterText, toggleSortDirection(), sortBy)" class="header-button">
              Name
              <span [ngClass]="{'arrow-up': sortBy === 'name' && sortOrder === 'ascending',
                                'arrow-down': sortBy === 'name' && sortOrder === 'descending'}"></span>
            </th>
            <th (click)="sortBy = 'tel'; institutionList(pa, selectedFilter, filterText, toggleSortDirection(), sortBy)" class="header-button">
              Tel
              <span [ngClass]="{'arrow-up': sortBy === 'tel' && sortOrder === 'ascending',
                                'arrow-down': sortBy === 'tel' && sortOrder === 'descending'}"></span>
            </th>
            <th (click)="sortBy = 'email'; institutionList(pa, selectedFilter, filterText, toggleSortDirection(), sortBy)" class="header-button">
              Email
              <span [ngClass]="{'arrow-up': sortBy === 'email' && sortOrder === 'ascending',
                                'arrow-down': sortBy === 'email' && sortOrder === 'descending'}"></span>
            </th>
            <th scope="col" *ngIf="showAdminComponents || showBrokerAdminComponents"></th>
          </tr>
          </thead>

          <tbody>
          <tr *ngFor="let institution of instData | paginate : { itemsPerPage: itemsPerPage, currentPage: pa, totalItems: instResponse?.totalNoOfRecords, id: 'institutionsASIA' }">
            <th scope="row">{{ institution.institutionId || '-' }}</th>
            <td>{{ institution.institutionCode || '-' }}</td>
            <td>{{ institution.institutionName || '-' }}</td>
            <td>{{ institution.officeTel || '-' }}</td>
            <td>{{ institution.email || '-' }}</td>
            <td class="d-flex justify-content-end">
              <button type="button" class="btn btn-info" (click)="openInstDetailsModal(institution)">
                <i class="custom-icon-button"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="position-absolute bottom-0 start-0 p-4">
        <div class="hstack gap-3">
          <div>Entries per page</div>
          <div mdbDropdown class="dropdown">
            <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton"
                    aria-expanded="false" mdbDropdownToggle>
              {{itemsPerPage}}
            </button>
            <ul mdbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li><a class="dropdown-item" (click)="pageSizeChanged(10)">10</a></li>
              <li><a class="dropdown-item" (click)="pageSizeChanged(20)">20</a></li>
              <li><a class="dropdown-item" (click)="pageSizeChanged(50)">50</a></li>
              <li><a class="dropdown-item" (click)="pageSizeChanged(100)">100</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="position-absolute bottom-0 end-0 p-4">
        <pagination-template id="institutionsASIA" #p="paginationApi" (pageChange)="pageChanged($event)">
          <nav>
            <ul class="pagination">
              <li class="page-item" style="cursor: pointer;" [ngClass]="p.isFirstPage() ? 'disabled' : ''">
                <a (click)="p.previous()" class="page-link">Previous</a>
              </li>
              <div *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
                <li class="page-item" style="cursor: pointer;" [ngClass]="p.getCurrent() === page.value ? 'active' : ''">
                  <a (click)="p.setCurrent(page.value)" class="page-link">{{ page.label }}</a>
                </li>
              </div>
              <li class="page-item" style="cursor: pointer;" [ngClass]="p.isLastPage() ? 'disabled' : ''">
                <a class="page-link" (click)="p.next()">Next</a>
              </li>
            </ul>
          </nav>
        </pagination-template>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid" style="position: relative;" *ngIf="showBrokerComponents">
  <hr>
  <div class="d-flex justify-content-center mt-5 mb-5">
    <div class="col-md-3 user-table2 position-relative">
      <div *ngFor="let institution of instDetails">
        <div class="mb-4"><strong>ID:</strong> {{ institution.institutionId || '-' }}</div>
        <div class="mb-4"><strong>Code:</strong> {{ institution.institutionCode || '-' }}</div>
        <div class="mb-4"><strong>Name:</strong> {{ institution.institutionName || '-' }}</div>
        <div class="mb-4"><strong>Tel:</strong> {{ institution.officeTel || '-' }}</div>
        <div class="mb-4"><strong>Email:</strong> {{ institution.email || '-' }}</div>
      </div>
    </div>
  </div>
</div>
